/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AssetCompositionType {
  Cash = "Cash",
  Instrument = "Instrument",
  SharesOutStanding = "SharesOutStanding",
  Unknown = "Unknown",
}

/**
 * Opening hours for atms
 */
export enum AtmOpeningHours {
  AlwaysOpen = "AlwaysOpen",
  BranchHours = "BranchHours",
  BusinessHours = "BusinessHours",
  Unknown = "Unknown",
}

/**
 * Types of Atm. f.x. deposit or currency
 */
export enum AtmType {
  Atm = "Atm",
  CoinCounterAtm = "CoinCounterAtm",
  CoinRollAtm = "CoinRollAtm",
  CorporateDepositAtm = "CorporateDepositAtm",
  CurrencyAtm = "CurrencyAtm",
  DepositAtm = "DepositAtm",
  GiftCardAtm = "GiftCardAtm",
}

export enum AukakronurPartnerOrderByOption {
  Discount = "Discount",
  Distance = "Distance",
  Name = "Name",
}

export enum AukakronurPartnerType {
  Car = "Car",
  Clothing = "Clothing",
  Gifts = "Gifts",
  Groceries = "Groceries",
  Health = "Health",
  Hobbies = "Hobbies",
  Home = "Home",
  Restaurants = "Restaurants",
  Traveling = "Traveling",
}

export enum BankAccountState {
  Closed = "Closed",
  Open = "Open",
  Terminated = "Terminated",
}

/**
 * If you want the highest or lowest change in bonds
 */
export enum BondOrder {
  Low = "Low",
  Rise = "Rise",
  Turnover = "Turnover",
}

/**
 * Services available at branches
 */
export enum BranchServices {
  CashierService = "CashierService",
  CorporateBankingService = "CorporateBankingService",
  FinanceConsultation = "FinanceConsultation",
  MailDelivery = "MailDelivery",
  RetailBankingService = "RetailBankingService",
  ServiceVisit = "ServiceVisit",
}

export enum ConsultationType {
  Appointment = "Appointment",
  Phonecall = "Phonecall",
  Videocall = "Videocall",
}

/**
 * All days in a week
 */
export enum Day {
  Friday = "Friday",
  Monday = "Monday",
  Saturday = "Saturday",
  Sunday = "Sunday",
  Thursday = "Thursday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
}

export enum DerivativeContractStatus {
  Closed = "Closed",
  Open = "Open",
}

/**
 * What source to read rates from
 */
export enum ExchangeRateSource {
  CentralBank = "CentralBank",
  Customs = "Customs",
  General = "General",
  Notes = "Notes",
  Spot = "Spot",
  Visa = "Visa",
}

export enum ExchangeSymbol {
  All = "All",
  FNIS = "FNIS",
  XICE = "XICE",
}

export enum FeeType {
  Amount = "Amount",
  Information = "Information",
  Label = "Label",
  Percentage = "Percentage",
}

export enum FundCategory {
  AllianceBernstein = "AllianceBernstein",
  BalancedFund = "BalancedFund",
  BondFund = "BondFund",
  EquityFund = "EquityFund",
  ExchangeTradedFund = "ExchangeTradedFund",
  GovernmentBondFund = "GovernmentBondFund",
  MoneyMarketFund = "MoneyMarketFund",
  PrivateBankingFund = "PrivateBankingFund",
  ShortTermFund = "ShortTermFund",
  UknownCategory = "UknownCategory",
}

/**
 * If you want the highest or lowest month return in funds
 */
export enum FundOrder {
  Low = "Low",
  Rise = "Rise",
}

export enum FundType {
  Etf = "Etf",
  MutualFund = "MutualFund",
}

export enum GdprUpdateType {
  Correction = "Correction",
  Deletion = "Deletion",
  Limitation = "Limitation",
}

export enum GeneralKnowledgeAssessment {
  Advanced = "Advanced",
  Basic = "Basic",
  Informed = "Informed",
  None = "None",
}

export enum HistoryGranularity {
  OneDay = "OneDay",
  OneHour = "OneHour",
}

export enum IndexType {
  Indexed = "Indexed",
  NotIndexed = "NotIndexed",
}

export enum InterestRateType {
  Deposit = "Deposit",
  Loan = "Loan",
}

export enum LoanProductPaymentType {
  Annuitet = "Annuitet",
  EqualInstallments = "EqualInstallments",
}

export enum MarketInstrumentOrderAction {
  Buy = "Buy",
  Sell = "Sell",
}

export enum MarketInstrumentOrderType {
  Amount = "Amount",
  Limit = "Limit",
  Market = "Market",
}

export enum MarketOrderStatus {
  Cancelled = "Cancelled",
  Completed = "Completed",
  Expired = "Expired",
  Open = "Open",
  Rejected = "Rejected",
}

/**
 * Is the market closed, open or wasOpen
 */
export enum MarketStatus {
  Closed = "Closed",
  Open = "Open",
  WasOpen = "WasOpen",
}

export enum MarketTransactionAction {
  Buy = "Buy",
  CustodyFee = "CustodyFee",
  Delivery = "Delivery",
  Dividend = "Dividend",
  Installment = "Installment",
  Interest = "Interest",
  PortfolioTransfer = "PortfolioTransfer",
  Reception = "Reception",
  Redemption = "Redemption",
  Sell = "Sell",
  StockSplit = "StockSplit",
}

export enum MarketTransactionStatus {
  Completed = "Completed",
  ConfirmedPrice = "ConfirmedPrice",
  New = "New",
  Settlement = "Settlement",
  UnconfirmedPrice = "UnconfirmedPrice",
}

/**
 * Opening hours for service locations
 */
export enum OpeningHours {
  AlwaysOpen = "AlwaysOpen",
  BusinessHours = "BusinessHours",
  Intervals = "Intervals",
  NotOpen = "NotOpen",
  UnknownPattern = "UnknownPattern",
  Weekdays = "Weekdays",
}

export enum OrderByDirection {
  Asc = "Asc",
  Desc = "Desc",
}

export enum PaymentType {
  Annuitet = "Annuitet",
  EqualInstallments = "EqualInstallments",
}

/**
 * Portfolio type
 */
export enum PortfolioType {
  AssetManagement = "AssetManagement",
  Custody = "Custody",
  Storage = "Storage",
}

/**
 * What type of product e.g. loan, creditcard, account
 */
export enum ProductType {
  Account = "Account",
  CreditCard = "CreditCard",
  Loan = "Loan",
  RealestateLoan = "RealestateLoan",
}

/**
 * Regions in Iceland
 */
export enum Region {
  All = "All",
  Austurland = "Austurland",
  Hofudborgarsvaedid = "Hofudborgarsvaedid",
  Nordurland = "Nordurland",
  Sudurland = "Sudurland",
  Sudurnes = "Sudurnes",
  Vestfirdir = "Vestfirdir",
  Vesturland = "Vesturland",
}

export enum RequestGdprDataType {
  AssetManagement = "AssetManagement",
  CustomerInfo = "CustomerInfo",
  Debt = "Debt",
  DebtCollection = "DebtCollection",
  Deposit = "Deposit",
  GeneralAnnouncement = "GeneralAnnouncement",
  JobApplication = "JobApplication",
  Loan = "Loan",
  Pension = "Pension",
  Securities = "Securities",
}

/**
 * The type of service location
 */
export enum ServiceLocationType {
  Atm = "Atm",
  Branch = "Branch",
  SmartBooking = "SmartBooking",
}

export enum ServicePointType {
  Atm = "Atm",
  Branch = "Branch",
}

export enum SmartBookingCustomerType {
  Company = "Company",
  Person = "Person",
  PersonAndCompany = "PersonAndCompany",
}

/**
 * If you want the highest, lowest, turnovers or all in stocks
 */
export enum StockOrder {
  All = "All",
  Low = "Low",
  MostTraded = "MostTraded",
  Rise = "Rise",
  Turnover = "Turnover",
}

export enum TradingComplianceInstrumentAction {
  Buy = "Buy",
  Sell = "Sell",
  Subscription = "Subscription",
}

export enum TradingComplianceInstrumentNotAllowedInformation {
  AppropriatenessTestUnanswered = "AppropriatenessTestUnanswered",
  IllegalDomicile = "IllegalDomicile",
  InstrumentDoseNotAllowTrading = "InstrumentDoseNotAllowTrading",
  InvalidLei = "InvalidLei",
  InvalidNci = "InvalidNci",
  NoBankAccount = "NoBankAccount",
  NoCustodialAgreement = "NoCustodialAgreement",
  NotAppropriate = "NotAppropriate",
  ReadAccess = "ReadAccess",
  Underage = "Underage",
  UserNotAllowedToTrade = "UserNotAllowedToTrade",
}

export enum TradingComplianceNextAction {
  AnswerAppropriatenessTest = "AnswerAppropriatenessTest",
  CanTrade = "CanTrade",
  CreateCustodialAccount = "CreateCustodialAccount",
  CreateCustodialAgreement = "CreateCustodialAgreement",
  NoActionAvailable = "NoActionAvailable",
  ShowEducation = "ShowEducation",
}

export enum VehicleEmissionType {
  Electric = "Electric",
  Gas = "Gas",
  Hybrid = "Hybrid",
}

/**
 * Svör við tilhlýðileikamati, fyrir kaup og sölu í sjóðum
 */
export interface AnswerTradingAppropriatenessTestInput {
  knowledge: GeneralKnowledgeAssessment;
  experience: GeneralKnowledgeAssessment;
  education: GeneralKnowledgeAssessment;
  jobExperience: GeneralKnowledgeAssessment;
  listedEquities: CategoryQuestionInput;
  listedBonds: CategoryQuestionInput;
  etfs: CategoryQuestionInput;
  ucitsFunds: CategoryQuestionInput;
  investmentFunds: CategoryQuestionInput;
}

export interface AukakronurPartnerLocationArgs {
  longitude: number;
  latitude: number;
}

export interface AukakronurPartnerOrderBy {
  fields: AukakronurPartnerOrderByOption[];
  direction?: OrderByDirection | null;
  location?: AukakronurPartnerLocationArgs | null;
}

export interface BookAppointmentInput {
  comment?: string | null;
  customer?: SmartBookingCustomerInput | null;
  company?: SmartBookingCompanyInput | null;
  reservationId: string;
}

export interface CancelAppointmentInput {
  id: string;
}

export interface CancelMarketSubscriptionInput {
  subscriptionId: string;
}

export interface CategoryQuestionInput {
  hasExperience: boolean;
  hasKnowledge: boolean;
}

export interface ContactUsInput {
  name: string;
  kennitala: string;
  email: string;
  phoneNumber: string;
  description: string;
}

export interface CreateMarketOrderInput {
  instrumentId: string;
  portfolioId: string;
  accountId: string;
  action: MarketInstrumentOrderAction;
  type: MarketInstrumentOrderType;
  quantity?: number | null;
  price?: number | null;
  amount?: number | null;
}

export interface CreateMarketSubscriptionInput {
  instrumentId: string;
  portfolioId: string;
  accountId: string;
  amount: number;
}

export interface CreatePensionApplicationInput {
  name: string;
  kennitala: string;
  phoneNumber: string;
  email: string;
}

export interface CreditAssessmentCalculatorCustomerArgs {
  income: number;
  hasLinPayments: boolean;
  overdraftCreditLimit?: number | null;
}

export interface EventRegistrationAttributeInput {
  label: string;
  value: string;
}

export interface EventRegistrationCustomerInput {
  name: string;
  kennitala?: string | null;
  email?: string | null;
  phonenumber?: string | null;
  companyname?: string | null;
  companykennitala?: string | null;
  numberRegistering: number;
  attributes?: EventRegistrationAttributeInput[] | null;
}

export interface FundKnowledgeInupt {
  fundId: string;
  hasKnowledge: boolean;
}

export interface OrderAukakronurCardInput {
  name: string;
  kennitala: string;
  phoneNumber: string;
  email: string;
  address?: string | null;
  zip?: string | null;
  place?: string | null;
}

export interface OrderGiftCardInput {
  name: string;
  kennitala: string;
  phoneNumber: string;
  email: string;
  numberOfGiftCards: number;
  amountOnEachCard: number;
  serviceLocationId?: string | null;
  servicePointId?: string | null;
  description?: string | null;
  employeeName?: string | null;
  withdrawalAccountNumber?: string | null;
}

export interface RealEstateLoanOptionInput {
  loanDurationMonths?: number | null;
  interestRate?: number | null;
  paymentType?: PaymentType | null;
  loanPaymentType?: LoanProductPaymentType | null;
  oneYearIndexProjection?: number | null;
}

export interface RequestGdprDataInput {
  types: RequestGdprDataType[];
  email: string;
  phoneNumber: string;
  formerSPCustomer?: boolean | null;
}

export interface SmartBookingCompanyInput {
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  kennitala: string;
}

export interface SmartBookingCustomer {
  name: string;
  kennitala: string;
  email: string;
  phone: string;
}

export interface SmartBookingCustomerInput {
  name: string;
  kennitala: string;
  email: string;
  phone: string;
  additionalCustomer?: SmartBookingCustomer | null;
}

export interface SubscribeToEmailListFields {
  key?: string | null;
  value?: string | null;
}

export interface SubscribeToEmailListInput {
  fields?: SubscribeToEmailListFields[] | null;
  mailinglists?: string[] | null;
  email?: string | null;
}

export interface UpdateCustodialAgreementInput {
  id?: string | null;
  sendStatementsAndReceiptsInMail?: boolean | null;
  tradingAppropriatenessTest?: AnswerTradingAppropriatenessTestInput | null;
  fundKnowledge?: FundKnowledgeInupt | null;
}

export interface UpdateGdprDataInput {
  type: GdprUpdateType;
  description: string;
  email?: string | null;
}

export interface UpdateMarketSubscriptionInput {
  subscriptionId: string;
  amount?: number | null;
  accountId?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
